import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    stylistProfile: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload.user
    },
    logout: (state, action) => {
      state.user = null
      localStorage.clear()
    },
    setStylistProfile: (state, action) => {
      state.stylistProfile = action.payload.stylistProfile
    },
  },
})

export const { setUser, logout, setStylistProfile } = userSlice.actions
export const selectUser = (state) => state.user
export default userSlice.reducer
